// extracted by mini-css-extract-plugin
export default {"LoginAdminButton_basic":"LoginAdminButton_LoginAdminButton_basic__2s-5h","LoginAdminButton_external":"LoginAdminButton_LoginAdminButton_external__t7DnY"};